import { ApiProperty } from "@nestjs/swagger";
import { IsOptional, Matches, MaxLength } from "class-validator";

export class AssetLicenseLogsDto{
    @ApiProperty()
    assetMaintainanceTransactionsId: number;

    @ApiProperty()
    licenseId: number;

    @ApiProperty()
    licenseName: number;

    @ApiProperty()
    referenceNumber: number;

    @ApiProperty()
    company:string;

    @ApiProperty()
    licenseNumber:string;

    @ApiProperty()
    responsibility:string;

    @ApiProperty()
    expiryDate:Date;

    @ApiProperty()
    renewalPersonName:string;

    @ApiProperty()
    renewalStartDate:Date;

    @ApiProperty()
    renewalExpiryDate:Date;

    @ApiProperty()
    isActive:boolean;

    @ApiProperty()
    createdAt : Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    createdUser: string;

    @ApiProperty()
    updatedAt : Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    plantId?:number

}